import {KeyTransaction} from "./Model";
import api from "../util/api";
import Subscription from "../util/Subscription";
import {useCurrentOfficeStore} from "./CurrentOfficeStore";


export const keyTransactionSubscription = new Subscription();

export async function executeKeyTransaction(
    transactions: KeyTransaction[],
) {
    const currentOfficeId = useCurrentOfficeStore.getState().officeId;
    if (currentOfficeId !== null) {
        await api.post(`/offices/${currentOfficeId}/key-transactions`, transactions);
        keyTransactionSubscription.notify();
    }
}